import { render, staticRenderFns } from "./GratificationDetail.vue?vue&type=template&id=27e41474&scoped=true"
import script from "./GratificationDetail.vue?vue&type=script&lang=js"
export * from "./GratificationDetail.vue?vue&type=script&lang=js"
import style0 from "./GratificationDetail.vue?vue&type=style&index=0&id=27e41474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e41474",
  null
  
)

export default component.exports